import { useQuery } from '@tanstack/react-query';

import { jobsQueryKeys } from '@/modules/jobs/queries/queryKeys';
import { scoutClient } from '@/modules/scout-sourcing/scoutClient';

export const useScoutTargetingSessionQuery = (jobId: string) =>
  useQuery({
    queryKey: jobsQueryKeys.scoutSession(jobId),
    queryFn: () => scoutClient.getSession(jobId),
    enabled: Boolean(jobId),
    staleTime: 0,
  });
